import CryptoJS from 'crypto-js/crypto-js'
// import { SM4Util } from 'sm4util';


// 解密
export function Decrypt(word) {
           let key = CryptoJS.enc.Utf8.parse("s%kld*spECslDa#a");
        let iv = CryptoJS.enc.Utf8.parse('03Q22$9V0(92&3*0')
    
        let base64 = CryptoJS.enc.Base64.parse(word);
        let src = CryptoJS.enc.Base64.stringify(base64);
    
        var decrypt = CryptoJS.AES.decrypt(src, key, {
          iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
    
        var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        if (!decryptedStr) {
          return word;
        }
        try {
          return JSON.parse(decryptedStr);
        } catch (e) {
          // 兼容手机号等非JSON明文场景
          return decryptedStr;
        }
  };
   //aes加密
   export function EncryptAes(word) {
    
    let key = CryptoJS.enc.Utf8.parse("s%kld*spECslDa#a");
    let iv = CryptoJS.enc.Utf8.parse('03Q22$9V0(92&3*0')

    let encrypted = CryptoJS.AES.encrypt(word, key, {  
      iv: iv,
      mode: CryptoJS.mode.CBC,  
      padding: CryptoJS.pad.Pkcs7  
  }); 
return encrypted.toString()
  }

// export function DecryptSM4(word) {
//     const sm4 = new SM4Util()    
//     let text = sm4.decryptCustom_ECB(word, 's%kld*spECslDa#a')
//    return JSON.parse(text)
// }